import {
  RiHome4Line,
  RiLineChartLine,
  RiFileTextLine,
  RiCustomerService2Line,
  RiNotification3Line,
} from '@remixicon/react';
import type { NavSection } from './types';

/**
 * KİRACI PORTALI MENÜSÜ.
 *
 * NEDEN AYRI DOSYA AMA AYNI TİP: Portal, yönetim arayüzüyle AYNI kabuğu
 * (sol menü + üst bar) kullanır; farklı olan yalnızca menü İÇERİĞİdir.
 * Aynı `NavSection` tipini paylaşmak, iki tarafın da aynı `Sidebar`
 * bileşeninden beslenmesini sağlar — ikinci bir menü bileşeni yazsaydık,
 * biri güncellendiğinde diğeri geride kalırdı.
 *
 * NEDEN TEK BÖLÜM: Kiracının beş ekranı var. Bunları "PANO / FİNANS /
 * OPERASYON" diye gruplamak, gruplama bilgisi taşımadan yalnızca menüyü
 * uzatırdı; bölüm başlıkları ancak seçenekler taranamayacak kadar
 * çoğaldığında işe yarar.
 */
export const PORTAL_NAV_SECTIONS: NavSection[] = [
  {
    id: 'portal',
    label: 'Menü',
    items: [
      { id: 'portal.home', label: 'Özet', icon: RiHome4Line, to: '/portal' },
      { id: 'portal.turnover', label: 'Ciro Beyanı', icon: RiLineChartLine, to: '/portal/ciro' },
      { id: 'portal.invoices', label: 'Faturalarım', icon: RiFileTextLine, to: '/portal/faturalar' },
      {
        id: 'portal.tickets',
        label: 'Taleplerim',
        icon: RiCustomerService2Line,
        to: '/portal/talepler',
      },
      {
        id: 'portal.announcements',
        label: 'Duyurular',
        icon: RiNotification3Line,
        to: '/portal/duyurular',
      },
    ],
  },
];
